export default {"src":"/_next/static/media/map_marker.8fa6e469.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};